module.exports = __webpack_public_path__ + "static/media/ojo.f4e8560d.svg";